interface MediaItem {
  title: string;
  sub: string;
  duration: string;
  tag: string;
  img: string;
  alt: string;
}

const mediaItems: MediaItem[] = [
  {
    title: '《流浪地球3》幕后特辑',
    sub: '揭秘科幻巨制的视觉特效与拍摄故事',
    duration: '45:28',
    tag: '电影花絮',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20sci-fi%20cinematic%20composition%20with%20deep%20space%20nebula%20glow%20and%20warm%20golden%20orange%20accents%2C%20futuristic%20visual%20effects%20aesthetic%2C%20dark%20background%20with%20soft%20light%20beams%2C%20film%20production%20atmosphere%2C%20no%20text%20no%20people&width=900&height=500&seq=media-scifi-01&orientation=landscape',
    alt: '流浪地球3幕后特辑',
  },
  {
    title: '《长安十二时辰》导演访谈',
    sub: '导演深度解析第二季的创作理念与拍摄细节',
    duration: '32:15',
    tag: '独家专访',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20ancient%20Chinese%20palace%20architecture%20silhouette%20with%20warm%20golden%20sunset%20glow%20on%20dark%20background%2C%20cinematic%20drama%20aesthetic%2C%20soft%20atmospheric%20lighting%2C%20elegant%20composition%2C%20no%20text%20no%20people&width=900&height=500&seq=media-historical-02&orientation=landscape',
    alt: '长安十二时辰导演访谈',
  },
  {
    title: '2026暑期档观影指南',
    sub: '盘点今年暑假最值得期待的影视作品TOP20',
    duration: '18:42',
    tag: '专题策划',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20summer%20cinema%20vibe%20with%20warm%20golden%20and%20amber%20sunset%20tones%2C%20floating%20geometric%20film%20reels%20on%20dark%20background%2C%20soft%20atmospheric%20haze%2C%20elegant%20entertainment%20aesthetic%2C%20no%20text%20no%20people&width=900&height=500&seq=media-summer-03&orientation=landscape',
    alt: '2026暑期档观影指南',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 rounded-full text-xs font-medium bg-primary-100 text-primary-700 mb-4 whitespace-nowrap">
            影音推荐
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            精彩推荐
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            独家内容与专题策划，深度观影体验
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {mediaItems.map((item) => (
            <div
              key={item.title}
              className="group bg-background-100 rounded-2xl overflow-hidden border border-background-200/80 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={item.img}
                  alt={item.alt}
                  className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-colors flex items-center justify-center">
                  <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-full bg-primary-500/90 group-hover:bg-primary-500 transition-colors shadow-lg">
                    <i className="ri-play-fill text-2xl md:text-3xl text-background-50 ml-1"></i>
                  </div>
                </div>
                <div className="absolute bottom-3 right-3">
                  <span className="px-2.5 py-1 rounded-full text-xs font-medium bg-black/60 text-background-50 backdrop-blur-sm whitespace-nowrap">
                    {item.duration}
                  </span>
                </div>
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full text-xs font-medium bg-accent-500/90 text-background-50 whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm md:text-base font-semibold text-foreground-950 mb-1 line-clamp-1">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 line-clamp-2">{item.sub}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}